export class EventDescriptionItem {
    public Header: string;
    public Value: any;

    constructor (header: string | undefined = undefined, value: any = undefined) {
        this.Header = header || '';
        this.Value = value || '';
    }
}
